<template>
  <div class="app-info" v-if="personalInfo">
    <h1>License / ID / Permit</h1>
    <div class="app-row">
        <div>
            <div v-if="personalInfo.credentialInformation">
                <div v-if="personalInfo.credentialInformation.credentialDetails.length > 0">
                <div class="app-cred-row" v-for="(credDetails, index) in personalInfo.credentialInformation.credentialDetails" :key="index">
                    <div class="app-cred-info-row">
                        <div class="app-cred-info-group">
                            <label for="licenseType">License type</label>                
                            <span for="licenseTypeText">{{ credDetails.licenseType }}</span>
                        </div>
                        <div class="app-cred-info-group">
                            <label for="licenseNumber">License number</label>
                            <span for="licenseNumberText">{{ credDetails.licenseNumber }}</span>
                        </div>
                        <div class="app-cred-info-group">
                            <label for="issueDate">Issue date</label>
                            <span for="issueDateText">{{ credDetails.issueDate }}</span>
                        </div>
                        <div class="app-cred-info-group">
                            <label for="expirationDate">Expiration date</label>
                            <span for="expirationDateText">{{ credDetails.expirationDate }}</span>
                        </div>
                    </div>
                    <div class="app-cred-info-row">
                        <div class="app-cred-info-group">
                            <label for="status">Status</label>
                            <img v-if="credDetails.credentialStatus == 'Active'" class="active-icon" src="static/status-active.png" alt="Icon">
                            <img v-else class="active-icon" src="static/status-not-active.png" alt="Icon">
                            <span for="statusText">{{ credDetails.credentialStatus }}</span>
                        </div>
                        <div class="app-cred-info-group">
                            <label for="realId">Real ID indicator</label>
                            <span for="realIdText">{{ credDetails.realIdIndicator }}</span>
                        </div>
                        <div class="app-cred-info-group">
                            <label for="endorsements">Endorsements
                                <span class="app-tooltip" tabindex="0" v-tooltip="{ content: credDetails.endorsements }" v-show="credDetails.endorsements!='None'">
                                    <img src="@ridmv/web-themes/images/icons/question-circle-solid.svg" alt="Definition">
                                    <span class="sr-only">{{ credDetails.endorsements }}</span>
                                </span>
                            </label>
                            <span :class="credDetails.endorsements!='None' ? 'app-codes' : '' " for="endorsementsText">{{ credDetails.endorsements | splitCodes }}</span>
                        </div>
                        <div class="app-cred-info-group">
                            <label for="restrictions">Restrictions
                                <span class="app-tooltip" tabindex="0" v-tooltip="{ content: credDetails.restrictions }" v-show="credDetails.restrictions!='None'">
                                    <img src="@ridmv/web-themes/images/icons/question-circle-solid.svg" alt="Definition">
                                    <span class="sr-only">{{ credDetails.restrictions }}</span>
                                </span>
                            </label>
                            <span :class="credDetails.restrictions!='None' ? 'app-codes' : '' " for="restrictionsText">{{ credDetails.restrictions | splitCodes}}</span>
                        </div>
                    </div>
                </div>
                </div>
                <div v-else><p class="text-mute">No License/ID/Permit found.</p></div>
            </div>
            <div v-if="personalInfo == null && !networkResponse.message">
                <p class="text-mute">No License/ID/Permit found.</p>
            </div>
            <div v-if="personalInfo == null" && networkResponse.message>
                <SystemAlert/>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as COMMONS from '../../store/_commons' 
import SystemAlert from '@/components/SystemAlert'
export default {
    name : 'Credentials',
      data () {
        return {
          
        }
      },
      components: {
        SystemAlert
      },
      filters: {
        splitCodes(val) {
            if(val=='None') {
                return val;
            } else {
            let arrstr = val.split(",");
            let result = '';
            for(let i=0; i<arrstr.length; i++) {
                let addComma = i!= arrstr.length-1 ? ', ' : ''; 
                result = result + '' + arrstr[i].trim().charAt(0) + addComma;
            }
            return result;
            }
        }
      },
      computed: {
        ...mapGetters({
            personalInfo: COMMONS.GUEST_PERSONAL_INFO,
        }),
      }
    }
</script>

<style scoped lang="scss">
.app-info-row {
    display: flex;
    flex-wrap: wrap;
    // gap: 1rem 3%;
    margin: 15px 0px 18px 0px;
    // line-height: 25px;
    border-bottom: 1px solid var(--ri-gray);
    span, label {
        font-size: 1rem;
    }

    .app-info-group {
        width: 28%;
        min-width: 140px;
        margin-bottom: 1.5rem;
        img {
            max-width: 70%;
            max-height: 150px; 
            position: relative;   
            // object-fit: cover;
            &:focus {
            outline-color: orange;
            }
        }
        .customerImage:after {
            content: " ";
            background: url(/static/photo_not_available.png);
            display: block;
            position: relative;
            background-size: contain;
            width: 100%;
            height: 150px; 
            margin-top: -20px;
        }
        // .noImage {
        //         min-width: 200px !important;
        //         max-height: 200px !important;
        //     }
    }
    .d-flex {
        display: grid;
        grid-template-columns: 180px 180px;
        gap: 1rem 8%;
        margin-left: 5rem;
        .app-info-child-group {
            width: 180px;
        }
    }
}
.app-cred-row {
    border-bottom: 1px solid #F2F2F2;
    padding: 0.8rem 2rem;
    // margin-bottom: 10px;
}
.app-cred-info-row {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem 5%;
    margin: 15px 0px 10px 0px;
    .app-cred-info-group {
        width: 200px;
        .app-tooltip {
            margin-left: 0.2rem;
            display: inline-block;
        }
        img {
            width: 18px;
            margin-bottom: -2px;
        }
        .active-icon {
            width: 25px;
            height: 25px;
            vertical-align: middle;
            padding-right: 5px;
            padding-bottom: 5px;
        }
        span {
            // display: block;
            line-height: 25px;
        }
        .app-codes {
            position: relative;
            top: -4px;
        }
    }
}
.app-cred-row:nth-child(odd) {
    background-color: #F2F2F2;
    // filter: contrast(1.5) brightness(0.9) grayscale(1.5);
}

.app-row {
    display: grid;
    gap: 1rem;
    // grid-template-columns: 70% 30%;
    // .text-mute:nth-child(odd) {
    //     background-color: #F2F2F2;
    // }
}

@media only screen and (max-width: 700px) {
    .app-cred-info-row, .app-info-row, .app-row  {
        display: block;
    }
    .app-info-row .d-flex .app-info-child-group {
        width: 100px;
    }
    .app-cred-info-row .app-cred-info-group {
        margin-bottom: 0.7rem;
    }
    .app-info-row .d-flex {
        margin-left: 0rem;
    }
}
@media only screen and (min-width: 600px) and (max-width: 760px) {
  .app-row {
    display: block;
  }
}
 
</style>